import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DosificacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DosificacionPage",
            ss: ss,
            ajax: {
                "url": ss.indexDosificacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'UnidadAcademica', name: 'ua.UnidadAcademica', title: 'Unidad Academica' },
                { data: 'Descripcion', name: 'd.Descripcion', title: 'Descripción' },
                { data: 'NumeroAutorizacion', name: 'd.NumeroAutorizacion', title: 'Número de Autorización'},
                { data: 'FechaLimiteEmision', name: 'd.FechaLimiteEmision', title: 'Fecha Lìmite de Emisión', searchable: false},
                // { data: 'Activo', name: 'Activo', title: 'Activo' },

                { data: 'Activo', name: 'd.Activo', title: 'Activo', render: function(data, type, row) {
                    if ( row.Activo == true ) {
                        return '<p class="text-success text-center mb-0 pb-0"><i class="fas fa-check"></i></i> Activo</p>';


                    } else if ( row.Activo == false ){
                        return '<p class="text-primary text-center mb-0 pb-0"><i class="fas fa-times"></i></i> Inactivo</p>';
                        
                    }
                }},

                { data: 'Estado', name: 'd.Estado', title: 'Estado', render: function(data, type, row) {
                    if ( row.Estado == true ) {
                        return '<p class="text-dark text-center mb-0 pb-0"><i class="fas fa-check"></i></i> Asignado</p>';


                    } else if ( row.Estado == false ){
                        return '<p class="text-info text-center mb-0 pb-0"><i class="fas fa-times"></i></i> Sin Asignar</p>';
                        
                    }
                }},
                
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            dosificaciones: [],
            dosificacion: {},
            unidadAcademicas: [],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getUnidadAcademica() {
            this.ss.listUnidadAcademica().then(
                (result) => {
                    let response = result.data;
                    this.unidadAcademicas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newDosificacion() {
            this.dosificacion = {};
            this.$refs['frm-dosificacion'].show();
        },
        showDosificacion(id) {
            this.isLoading=true;
            this.ss.showDosificacion(id).then(
                (result) => {
                    let response = result.data;
                    this.dosificacion = response.data;
                    this.$refs['view-dosificacion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDosificacion() {
            this.$refs['frm-dosificacion'].show();
            this.$refs['view-dosificacion'].hide();
        },
        cancelDosificacion() {
            if (this.dosificacion.id) {
                this.$refs['view-dosificacion'].show();
            }
            this.$refs['frm-dosificacion'].hide();
        },
        saveDosificacion() {
            this.ss.storeDosificacion(this.dosificacion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-dosificacion'].hide();
                    this.$refs['datatable-dosificacion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteDosificacion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyDosificacion(this.dosificacion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-dosificacion'].hide();
                                this.$refs['datatable-dosificacion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Dosificacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDosificacion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        } else {
            this.getUnidadAcademica();
        }
    }
};
